{
  "EMOJI": {
    "PLACEHOLDER": "Cerca emojis",
    "NOT_FOUND": "Cap emoji coincideix amb la teva cerca",
    "REMOVE": "Suprimeix"
  }
}
